import { render, staticRenderFns } from "./customerServiceData.vue?vue&type=template&id=3d45cd34&scoped=true"
import script from "./customerServiceData.vue?vue&type=script&lang=js"
export * from "./customerServiceData.vue?vue&type=script&lang=js"
import style0 from "./customerServiceData.vue?vue&type=style&index=0&id=3d45cd34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45cd34",
  null
  
)

export default component.exports